export const API_ENDPOINT = 'https://secure.poker-navi.jp/api/v1/'
//export const API_ENDPOINT = 'https://secure-stg.poker-navi.jp/api/v1/'
